import { createFileRoute } from '@tanstack/react-router';
import { PetSocial } from '@/pet/src/components/social/PetSocial';
import { useAuth } from '@/context/AuthContext';
import { usePets } from '@/pet/src/context/PetsContext';

export const Route = createFileRoute('/dashboard/social')({
  component: PetsoSocial,
  validateSearch: (s: Record<string, unknown>) => ({
    openChat: typeof s?.openChat === 'string' ? s.openChat : undefined,
    create: s?.create === '1' || s?.create === true,
    park: typeof s?.park === 'string' ? s.park : undefined,
  }),
});

function PetsoSocial() {
  const { user } = useAuth();
  const { pets } = usePets();
  const { openChat, create, park } = Route.useSearch();
  const userId = user?.clerkId ?? 'user-1';

  return (
    <PetSocial
      userType="owner"
      userId={userId}
      pets={pets ?? []}
      initialOpenChat={openChat}
      initialCreatePost={create}
      initialParkContext={park}
    />
  );
}
